/**
 * Determines whether a route is allowed
 * for quantity_surveyor users.
 */

const staticAllowedRoutes = [
  "/",
  "/profile",
  "/organization",
  "/admin",
  "/project/new",
  "/project/smart-surveyor",
];

export const isQuantitySurveyorRouteAllowed = (pathname: string): boolean => {
  if (staticAllowedRoutes.includes(pathname)) {
    return true;
  }

  // Allow:
  // /project/:id
  // /project/:id/sections
  // const projectMatch = pathname.match(/^\/project\/[^/]+$/);
  // const projectSectionsMatch = pathname.match(/^\/project\/[^/]+\/sections$/);
  const projectSmartSurveyorMatch = pathname.match(
    /^\/project\/[^/]+\/smart-surveyor$/,
  );
  const projectSmartSurveyorV3Match = pathname.match(
    /^\/project\/[^/]+\/smart-surveyor-v3$/,
  );
  const projectSmartSurveyorWithIdMatch = pathname.match(
    /^\/project\/smart-surveyor\/[^/]+$/,
  );
  const projectSmartSurveyorUploadMatch = pathname.match(
    /^\/project\/[^/]+\/smart-surveyor\/upload$/,
  );
  const projectSmartSurveyorResearchMatch = pathname.match(
    /^\/project\/[^/]+\/smart-surveyor\/research$/,
  );

  const projectSmartSurveyorResearchChatMatch = pathname.match(
    /^\/project\/[^/]+\/smart-surveyor\/research\/chat$/,
  );



  if (
    projectSmartSurveyorMatch ||
    projectSmartSurveyorWithIdMatch ||
    projectSmartSurveyorUploadMatch ||
    projectSmartSurveyorV3Match ||
    projectSmartSurveyorResearchMatch ||
    projectSmartSurveyorResearchChatMatch
  ) {
    return true;
  }

  return false;
};
